<template>
	<div class="inquiry-container">
		<div class="null-page" v-show="yes"></div>
		
		<div class="inquiry-content" v-loading="loading">
			<!-- 发布询价单按钮 -->
			<div v-if="inquiryList.length > 0" class="release-button-top">
				<el-button type="primary" @click="releaseInquiry">发布询价单</el-button>
			</div>
			
			<!-- 状态标签页 -->
			<el-tabs v-model="activeName" @tab-click="handleTabClick">
				<el-tab-pane 
					v-for="(statusItem, statusIndex) in statusList" 
					:key="statusIndex"
					:label="`${statusItem.name}(${statusItem.count || 0})`" 
					:name="statusItem.status"
				>
				</el-tab-pane>
			</el-tabs>

			<!-- 询价列表 -->
			<div class="inquiry-list" v-if="inquiryList.length > 0">
				<div class="inquiry-item" v-for="(inquiryItem, inquiryIndex) in inquiryList" :key="inquiryIndex">
					<!-- 询价单头部信息 -->
					<div class="inquiry-header">
						<div class="inquiry-info">
							<div class="inquiry-title">{{ inquiryItem.product_name }}</div>
							<div class="inquiry-meta">
								<span class="meta-item">
									<label>产品分类：</label>
									<span>{{ inquiryItem.category_name }}</span>
								</span>
								<span class="meta-item">
									<label>需求数量：</label>
									<span>{{ inquiryItem.quantity }}</span>
								</span>
								<span class="meta-item">
									<label>需求有效期：</label>
									<span>{{ inquiryItem.validDate || inquiryItem.valid_until }}</span>
								</span>
							</div>
							<div class="inquiry-meta">
								<span class="meta-item">
									<label>期望到货日期：</label>
									<span>{{ inquiryItem.deliveryEndDate || '待定' }}</span>
								</span>
								<span class="meta-item">
									<label>发布日期：</label>
									<span>{{ inquiryItem.publishDate || '2024.12.23' }}</span>
								</span>
							</div>
						</div>
						<div class="inquiry-image">
							<img 
								:src="inquiryItem.productImages && inquiryItem.productImages[0] ? $img(inquiryItem.productImages[0]) : '/static/images/default-product.png'" 
								@error="imageError"
								alt="产品图片"
							/>
						</div>
					</div>

					<!-- 提示信息 -->
					<div v-if="inquiryItem.tips && inquiryItem.tips.length > 0" class="inquiry-tips">
						<div v-for="(tip, tipIndex) in inquiryItem.tips" :key="tipIndex" class="tip-item">
							<i class="el-icon-info"></i>
							<span>{{ tip }}</span>
						</div>
					</div>

					<!-- 询价单底部操作 -->
					<div class="inquiry-footer">
						<div class="status-info">
							<span class="status-label">询价单状态：</span>
							<span class="status-value" :class="'status-' + inquiryItem.status">
								{{ inquiryItem.status_name }}
							</span>
						</div>
						<div class="action-buttons">
							<el-button size="small" @click="inquiryDetail(inquiryItem)">
								查看详情
							</el-button>
							<el-button 
								v-if="inquiryItem.status === 0" 
								size="small" 
								type="warning" 
								@click="cancelInquiry(inquiryItem)"
							>
								撤销
							</el-button>
							<el-button 
								v-if="inquiryItem.status === -1 || inquiryItem.status === -2" 
								size="small" 
								type="primary" 
								@click="editInquiry(inquiryItem)"
							>
								重新编辑
							</el-button>
							<el-button 
								v-if="inquiryItem.status === 1" 
								size="small" 
								type="success" 
								@click="inquiryDetail(inquiryItem)"
							>
								查看供应商
							</el-button>
						</div>
					</div>
				</div>
			</div>

			<!-- 空状态 -->
			<div v-else-if="!loading && !inquiryList.length" class="empty-state">
				<div class="empty-content">
					<span style="margin-bottom: 40px;color:#999">暂无询价单</span>
					<div class="empty-title">发询价单，官方为你找厂!</div>
					<div class="empty-subtitle">
						询价单是帮助买家快速找供应商的询价工具! 免费发布询价单可以获得以下服务
					</div>
					<el-button type="primary" @click="releaseInquiry">发布询价单</el-button>
				</div>
			</div>

			<!-- 分页 -->
			<div class="pagination-wrap" v-if="inquiryList.length > 0">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pageInfo.page"
					:page-size="pageInfo.page_size"
					:total="total"
					background
					:pager-count="5"
					prev-text="上一页"
					next-text="下一页"
					hide-on-single-page
					layout="total, sizes, prev, pager, next, jumper"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import http from "@/utils/http"
import { getInquiryList, getInquiryDetail, cancelInquiry, republishInquiry, getInquiryStatusCount } from '@/api/inquiry'
import { getGoodsCategoryList } from '@/api/goods/goodscategory'

export default {
	name: "InquiryList",
	data() {
		return {
			activeName: 'all',
			loading: false,
			yes: true,
			statusList: [
				{
					status: 'all',
					name: '全部',
					count: 0
				},
				{
					status: 'auditing',
					name: '审核中',
					count: 0
				},
				{
					status: 'quoting',
					name: '报价中',
					count: 0
				},
				{
					status: 'finished',
					name: '已完结',
					count: 0
				}
			],
			inquiryList: [],
			categoryList: [],
			categoryMap: {},
			pageInfo: {
				page: 1,
				page_size: 10
			},
			total: 0
		}
	},
	mounted() {
		this.getCategoryList()
		this.getInquiryList()
	},
	methods: {
		/**
		 * 标签页切换
		 */
		handleTabClick(tab) {
			this.activeName = tab.name
			this.pageInfo.page = 1
			this.getInquiryList()
		},

		/**
		 * 获取询价列表
		 */
		getInquiryList() {
			this.loading = true
			
			http({
				url: '/api/inquiry/list',
				data: {
					page: this.pageInfo.page,
					status: this.activeName,
					page_size: this.pageInfo.page_size
				}
			}).then(res => {
				this.loading = false
				
				if (res.code === 0 && res.data && res.data.list) {
					// 适配新的数据结构：data.list.data
					let newArr = res.data.list.data || []
					
					// 更新状态统计数据
					if (res.data.count) {
						this.updateStatusCount(res.data.count)
					}
					
					// 处理数据格式化
					newArr.forEach(item => {
						this.formatInquiryItem(item)
					})
					
					this.inquiryList = newArr
					this.total = res.data.list.total || 0
				} else {
					this.$message.error(res.message || '获取数据失败')
					this.inquiryList = []
					this.total = 0
				}
			}).catch(err => {
				this.loading = false
				this.$message.error('网络错误，请重试')
				console.error('获取询价列表失败:', err)
			})
		},

		/**
		 * 格式化询价单数据
		 */
		formatInquiryItem(item) {
			// 处理图片数据 - 支持数组和JSON字符串格式
			if (item.product_images) {
				if (typeof item.product_images === 'string') {
					try {
						// 处理双重JSON编码的情况
						let images = JSON.parse(item.product_images)
						if (typeof images === 'string') {
							images = JSON.parse(images)
						}
						item.productImages = Array.isArray(images) ? images : [images]
					} catch (e) {
						item.productImages = [item.product_images]
					}
				} else if (Array.isArray(item.product_images)) {
					item.productImages = item.product_images
				} else {
					item.productImages = []
				}
			} else {
				item.productImages = []
			}
			
			// 格式化日期
			if (item.validity_date) {
				item.validDate = item.validity_date
			}
			if (item.expected_arrival_date) {
				item.deliveryEndDate = item.expected_arrival_date
			}
			if (item.create_time) {
				item.publishDate = item.create_time.split(' ')[0].replace(/-/g, '.')
			}
			
			// 设置询价单ID
			item.inquiry_id = item.id
			
			// 根据category_id设置分类名称
			if (item.category_id) {
				item.category_name = this.getCategoryName(item.category_id)
			} else if (!item.category_name) {
				item.category_name = '未分类'
			}
			
			// 处理提示信息
			item.tips = []
			if (item.status == -1 && item.reject_reason) {
				item.tips.push('审核反馈：' + item.reject_reason)
			}
			// 可以根据其他状态添加更多提示信息
			if (item.status == 1) {
				if(item.quotes && item.quotes.length == 1){
					// 报价中状态的提示信息可以从其他字段获取
					item.tips.push('报价供应商：' + item.quotes[0].site_name)
					item.tips.push('报价信息：' + item.quotes[0].price)
					item.tips.push('附加信息：' + item.quotes[0].additional_info)
				}else if(item.quotes && item.quotes.length > 1){
					item.tips.push('已获得 ' + item.quotes.length + ' 个报价')
				}
			}

			if (item.status == 2) {
				if(item.quotes && item.quotes.length > 1){
					item.tips.push('累计获得 ' + item.quotes.length + ' 个报价')
				}
			}
		},

		/**
		 * 获取产品分类数据
		 */
		getCategoryList() {
			http({
				url: '/api/goodscategory/tree',
				data: {}
			}).then(res => {
				if (res.code === 0 && res.data) {
					this.categoryList = res.data
					this.buildCategoryMap(res.data)
				}
			}).catch(err => {
				console.error('获取分类数据失败:', err)
			})
		},

		/**
		 * 构建分类ID到名称的映射
		 */
		buildCategoryMap(categories) {
			this.categoryMap = {}
			const buildMap = (items) => {
				items.forEach(item => {
					this.categoryMap[item.category_id] = item.category_name
					// 如果有子分类，递归处理
					if (item.children && item.children.length > 0) {
						buildMap(item.children)
					}
				})
			}
			buildMap(categories)
		},

		/**
		 * 根据分类ID获取分类名称
		 */
		getCategoryName(categoryId) {
			return this.categoryMap[categoryId] || '未分类'
		},

		/**
		 * 更新状态统计数据
		 */
		updateStatusCount(countData) {
			this.statusList.forEach(status => {
				if (countData[status.status] !== undefined) {
					status.count = countData[status.status]
				}
			})
		},

		/**
		 * 查看询价详情
		 */
		inquiryDetail(data) {
			// 跳转到询价详情页面
			this.$router.push({
				path: '/member/inquiry_detail',
				query: {
					inquiry_id: data.inquiry_id
				}
			})
		},

		/**
		 * 撤销询价单
		 */
		cancelInquiry(data) {
			// 先判断当前询价单的状态是否为0（审核中）
			if (data.status !== 0) {
				this.$message.warning('当前状态不支持撤销')
				return
			}
			
			this.$confirm('确定要撤销这个询价单吗？', '确认撤销', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				http({
					url: '/api/inquiry/cancel',
					data: {
						id: data.inquiry_id || data.id
					}
				}).then(res => {
					if (res.code === 0) {
						this.$message.success('操作成功')
						// 刷新列表
						this.getInquiryList()
					} else {
						this.$message.error(res.message || '操作失败')
					}
				}).catch(err => {
					this.$message.error('网络错误，请重试')
				})
			}).catch(() => {
				// 用户取消操作
			})
		},

		/**
		 * 编辑询价单
		 */
		editInquiry(inquiryItem) {
			// 跳转到询价编辑页面
			this.$router.push({
				path: '/member/inquiry_submit',
				query: {
					inquiry_id: inquiryItem.id,
					mode: 'edit'
				}
			})
		},

		/**
		 * 发布询价单
		 */
		releaseInquiry() {
			// 跳转到询价发布页面
			this.$router.push({
				path: '/member/inquiry_submit'
			})
		},

		/**
		 * 分页大小改变
		 */
		handleSizeChange(val) {
			this.pageInfo.page_size = val
			this.pageInfo.page = 1
			this.getInquiryList()
		},

		/**
		 * 当前页改变
		 */
		handleCurrentChange(val) {
			this.pageInfo.page = val
			this.getInquiryList()
		},

		/**
		 * 图片加载错误处理
		 */
		imageError(e) {
			e.target.src = '/static/images/default-product.png'
		}
	}
}
</script>

<style lang="scss" scoped>
.inquiry-container {
	padding: 20px;
	background-color: #f5f5f5;
	min-height: 100vh;

	.inquiry-content {
		background: #fff;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 20px;
	}

	.inquiry-list {
		.inquiry-item {
			border: 1px solid #e8e8e8;
			border-radius: 8px;
			padding: 20px;
			margin-bottom: 16px;
			background: #fff;
			transition: box-shadow 0.3s;

			&:hover {
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
			}

			.inquiry-header {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				margin-bottom: 16px;

				.inquiry-info {
					flex: 1;
					margin-right: 20px;

					.inquiry-title {
						font-size: 16px;
						font-weight: bold;
						color: #333;
						margin-bottom: 12px;
						line-height: 1.4;
					}

					.inquiry-meta {
						display: flex;
						flex-wrap: wrap;
						margin-bottom: 8px;

						.meta-item {
							margin-right: 24px;
							font-size: 14px;
							color: #666;

							label {
								color: #999;
								margin-right: 4px;
							}
						}
					}
				}

				.inquiry-image {
					width: 120px;
					height: 120px;
					flex-shrink: 0;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 6px;
						background-color: #f5f5f5;
					}
				}
			}

			.inquiry-tips {
				background-color: #f8f9fa;
				border-radius: 6px;
				padding: 12px 16px;
				margin-bottom: 16px;

				.tip-item {
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #666;
					line-height: 1.5;
					margin-bottom: 6px;

					&:last-child {
						margin-bottom: 0;
					}

					i {
						margin-right: 6px;
						color: #409eff;
					}
				}
			}

			.inquiry-footer {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-top: 16px;
				border-top: 1px solid #f0f0f0;

				.status-info {
					display: flex;
					align-items: center;

					.status-label {
						font-size: 14px;
						color: #666;
						margin-right: 8px;
					}

					.status-value {
						font-size: 14px;
						font-weight: 500;

						&.status-0 {
							color: #e6a23c;
						}

						&.status-1 {
							color: #409eff;
						}

						&.status-2 {
							color: #67c23a;
						}

						&.status--1,
						&.status--2 {
							color: #f56c6c;
						}
					}
				}

				.action-buttons {
					display: flex;
					gap: 8px;
				}
			}
		}
	}

	.empty-state {
		text-align: center;
		padding: 60px 20px;

		.empty-content {
			.empty-image {
				width: 200px;
				height: 150px;
				margin-bottom: 20px;
			}

			.empty-title {
				font-size: 18px;
				font-weight: bold;
				color: #333;
				margin-bottom: 12px;
			}

			.empty-subtitle {
				font-size: 14px;
				color: #666;
				margin-bottom: 24px;
				line-height: 1.5;
			}
		}
	}

	.pagination-wrap {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}

	.release-button-top {
		text-align: right;
		margin-bottom: 20px;
	}
}
</style>